import { createAsyncThunk } from '@reduxjs/toolkit'
import apiRequest from '../../lib/http'
import { normalizeError } from '../../utils/errorHelpers'

export const createContactLink = createAsyncThunk('contactLinks/create', async (data, { rejectWithValue }) => {
  try {
    const response = await apiRequest.post('/contact-links', data)
    return response.data.data
  } catch (error) {
    return rejectWithValue(normalizeError(error))
  }
})

export const getContactLinksByUserId = createAsyncThunk('contactLinks/getByUserId', async (userId, { rejectWithValue }) => {
  try {
    const response = await apiRequest.get(`/contact-links/users/${userId}`)
    return response.data.data
  } catch (error) {
    return rejectWithValue(normalizeError(error))
  }
})

export const deactivateContactLink = createAsyncThunk('contactLinks/deactivate', async (linkId, { rejectWithValue }) => {
  try {
    const response = await apiRequest.delete(`/contact-links/${linkId}`)
    return response.data.data
  } catch (error) {
    return rejectWithValue(normalizeError(error))
  }
})
